(function () {
  const SECTION_SELECTOR = '[data-rf-collection-listing]';

  function isMobile() {
    return window.matchMedia('(max-width: 991px)').matches;
  }

  function animateGrid(section) {
    const grid = section.querySelector('#CollectionProductGrid');
    if (!grid) return;

    grid.classList.remove('is-visible');
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        grid.classList.add('is-visible');
      });
    });
  }

  function getFilterForm(section) {
    return section.querySelector('#CollectionFiltersForm');
  }

  function buildSearchParamsFromForm(form) {
    const formData = new FormData(form);
    let searchParams = new URLSearchParams(formData).toString();
    const cfForm = form.closest('collection-filters-form');
    if (cfForm && typeof cfForm.onConvertPrice === 'function') {
      searchParams = cfForm.onConvertPrice(searchParams);
    }
    return searchParams;
  }

  function renderWithParams(section, searchParams, event) {
    animateGrid(section);
    ensureCollectionFiltersPatch();

    if (typeof CollectionFiltersForm !== 'undefined' && typeof CollectionFiltersForm.renderPage === 'function') {
      CollectionFiltersForm.renderPage(searchParams, event || null, true);
      return;
    }

    renderCollectionSection(section, searchParams, event);
  }

  async function renderCollectionSection(section, searchParams, event) {
    const sectionId = section?.dataset.sectionId;
    if (!sectionId) return;

    const url = `${window.location.pathname}?section_id=${encodeURIComponent(sectionId)}&${searchParams}`;
    document.body.classList.add('has-halo-loader');

    try {
      const response = await fetch(url);
      const html = await response.text();
      applyCollectionSectionHtml(html, event);
      history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams ? `?${searchParams}` : ''}`);
    } finally {
      document.body.classList.remove('has-halo-loader');
      animateGrid(section);
    }
  }

  function applyCollectionSectionHtml(html, event) {
    if (typeof CollectionFiltersForm !== 'undefined') {
      try {
        CollectionFiltersForm.renderFilters(html, event);
      } catch (error) {
        /* filters update optional */
      }
      try {
        CollectionFiltersForm.renderProductGrid(html);
      } catch (error) {
        replaceCollectionGrid(html);
      }
    } else {
      replaceCollectionGrid(html);
    }

    finalizeCollectionUpdate(html);
  }

  function replaceCollectionGrid(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const nextInner = parsed.getElementById('CollectionProductGrid')?.querySelector('.collection')?.innerHTML;
    const liveCollection = document.getElementById('CollectionProductGrid')?.querySelector('.collection');
    if (nextInner != null && liveCollection) {
      liveCollection.innerHTML = nextInner;
    }
  }

  function syncSortSelects(section, value) {
    const hiddenSort = section.querySelector('#SortBy');
    const desktopSort = section.querySelector('[data-rf-sort-select]');
    if (hiddenSort) hiddenSort.value = value;
    if (desktopSort) desktopSort.value = value;
    section.querySelectorAll('[data-rf-mobile-sort] .rf-collection-sheet__sort-option').forEach((btn) => {
      btn.classList.toggle('is-active', btn.dataset.value === value);
    });
  }

  function applySort(section, value) {
    syncSortSelects(section, value);
    const form = getFilterForm(section);
    if (!form) return;
    renderWithParams(section, buildSearchParamsFromForm(form));
  }

  function findFilterInput(group, paramName, paramValue) {
    return group.querySelector(`input[name="${paramName.replace(/"/g, '\\"')}"][value="${paramValue.replace(/"/g, '\\"')}"]`);
  }

  function findMatchingRadioButton(group, btn) {
    if (btn.hasAttribute('data-rf-filter-all')) {
      return group.querySelector('[data-rf-filter-all]');
    }
    return Array.from(group.querySelectorAll('[data-rf-filter-radio]')).find(
      (candidate) => candidate.dataset.paramName === btn.dataset.paramName
        && candidate.dataset.paramValue === btn.dataset.paramValue
    );
  }

  function selectRadioInGroup(group, activeBtn) {
    group.querySelectorAll('[data-rf-filter-radio]').forEach((btn) => {
      const isActive = btn === activeBtn;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    group.querySelectorAll('.rf-filter-radio__input').forEach((input) => {
      input.checked = false;
    });

    if (!activeBtn.hasAttribute('data-rf-filter-all')) {
      const input = findFilterInput(group, activeBtn.dataset.paramName, activeBtn.dataset.paramValue);
      if (input) input.checked = true;
    }
  }

  function applyFiltersFromForm(section) {
    const form = getFilterForm(section);
    if (!form) return;
    renderWithParams(section, buildSearchParamsFromForm(form));
  }

  function getSortOnlyParams(section) {
    const sortBy = section.querySelector('#SortBy')?.value
      || section.querySelector('[data-rf-sort-select]')?.value
      || 'manual';
    return sortBy ? `sort_by=${encodeURIComponent(sortBy)}` : '';
  }

  function updateSidebarClearVisibility(html) {
    const clearBtn = document.querySelector('[data-rf-clear-all-sidebar]');
    if (!clearBtn) return;

    if (html) {
      const source = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-rf-clear-all-sidebar]');
      if (source) {
        clearBtn.disabled = source.hasAttribute('disabled');
        return;
      }
    }

    const params = new URLSearchParams(window.location.search);
    let hasFilter = false;
    params.forEach((_, key) => {
      if (key.startsWith('filter.')) hasFilter = true;
    });
    clearBtn.disabled = !hasFilter;
  }

  function clearAllFilters(section) {
    renderWithParams(section, getSortOnlyParams(section));
    closeSheets(section);
  }

  function syncMobileRadiosFromDesktop(section) {
    section.querySelectorAll('[data-rf-sheet-filters] [data-rf-filter-radio-group]').forEach((mobileGroup) => {
      const desktopGroup = section.querySelector(
        `.rf-collection-filters__groups .js-filter[data-index="${mobileGroup.dataset.index}"]`
      );
      if (!desktopGroup) return;

      const activeDesktopBtn = desktopGroup.querySelector('[data-rf-filter-radio].is-active');
      if (!activeDesktopBtn) return;

      const mobileBtn = findMatchingRadioButton(mobileGroup, activeDesktopBtn);
      if (mobileBtn) selectRadioInGroup(mobileGroup, mobileBtn);
    });
  }

  function syncDesktopFromMobileRadios(section) {
    section.querySelectorAll('[data-rf-sheet-filters] [data-rf-filter-radio-group]').forEach((mobileGroup) => {
      const desktopGroup = section.querySelector(
        `.rf-collection-filters__groups .js-filter[data-index="${mobileGroup.dataset.index}"]`
      );
      if (!desktopGroup) return;

      const activeMobileBtn = mobileGroup.querySelector('[data-rf-filter-radio].is-active');
      if (!activeMobileBtn) return;

      const desktopBtn = findMatchingRadioButton(desktopGroup, activeMobileBtn);
      if (desktopBtn) selectRadioInGroup(desktopGroup, desktopBtn);
    });
  }

  function populateMobileSheet(section) {
    const target = section.querySelector('[data-rf-sheet-filters]');
    const sidebarGroups = section.querySelector('.rf-collection-filters__groups');
    if (!target || !sidebarGroups) return;

    target.innerHTML = '';
    sidebarGroups.querySelectorAll('.rf-filter-group').forEach((group) => {
      target.appendChild(group.cloneNode(true));
    });

    const help = section.querySelector('.rf-collection-help--sidebar');
    if (help) {
      target.appendChild(help.cloneNode(true));
    }

    syncMobileRadiosFromDesktop(section);
  }

  function openSheet(section, name) {
    const sheet = section.querySelector(`[data-rf-sheet="${name}"]`);
    if (!sheet) return;
    if (name === 'filter') populateMobileSheet(section);
    sheet.hidden = false;
    sheet.classList.add('is-open');
    document.body.classList.add('rf-collection-sheet-open');
  }

  function closeSheets(section) {
    section.querySelectorAll('.rf-collection-sheet').forEach((sheet) => {
      sheet.classList.remove('is-open');
      sheet.hidden = true;
    });
    document.body.classList.remove('rf-collection-sheet-open');
  }

  function bindAddToCart(section) {
    section.addEventListener('submit', async (event) => {
      const form = event.target.closest('[data-rf-atc-form]');
      if (!form) return;

      event.preventDefault();
      event.stopPropagation();

      const button = form.querySelector('[data-rf-atc-btn]');
      const formData = new FormData(form);

      try {
        const response = await fetch(window.Shopify?.routes?.root ? `${window.Shopify.routes.root}cart/add.js` : '/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData,
        });

        if (!response.ok) throw new Error('Add to cart failed');

        if (button) {
          button.classList.add('is-added');
          button.textContent = 'Added!';
        }
      } catch (error) {
        form.submit();
      }
    });
  }

  function bindFilterRadios(section) {
    section.addEventListener('click', (event) => {
      const btn = event.target.closest('[data-rf-filter-radio]');
      if (!btn || btn.disabled || btn.classList.contains('is-disabled')) return;

      const group = btn.closest('[data-rf-filter-radio-group]');
      if (!group || !section.contains(group)) return;

      if (btn.classList.contains('is-active')) return;

      selectRadioInGroup(group, btn);

      const inSheet = btn.closest('[data-rf-sheet-filters]');
      if (isMobile() && inSheet) return;

      applyFiltersFromForm(section);
    });
  }

  function bindClearFilters(section) {
    section.addEventListener('click', (event) => {
      const clearAllBtn = event.target.closest('[data-rf-clear-all]');
      if (!clearAllBtn || !section.contains(clearAllBtn) || clearAllBtn.disabled) return;

      event.preventDefault();
      clearAllFilters(section);
    });
  }

  function bindSort(section) {
    const desktopSort = section.querySelector('[data-rf-sort-select]');
    if (desktopSort) {
      desktopSort.addEventListener('change', () => {
        applySort(section, desktopSort.value);
      });
    }

    section.querySelectorAll('[data-rf-mobile-sort] .rf-collection-sheet__sort-option').forEach((btn) => {
      btn.addEventListener('click', () => {
        applySort(section, btn.dataset.value);
        closeSheets(section);
      });
    });
  }

  function bindSheets(section) {
    section.querySelector('[data-rf-open-filters]')?.addEventListener('click', () => openSheet(section, 'filter'));
    section.querySelector('[data-rf-open-sort]')?.addEventListener('click', () => openSheet(section, 'sort'));

    section.querySelectorAll('[data-rf-close-sheet]').forEach((el) => {
      el.addEventListener('click', () => closeSheets(section));
    });

    section.querySelector('[data-rf-mobile-apply]')?.addEventListener('click', () => {
      syncDesktopFromMobileRadios(section);
      applyFiltersFromForm(section);
      closeSheets(section);
    });

    section.querySelector('[data-rf-mobile-clear]')?.addEventListener('click', () => {
      clearAllFilters(section);
    });
  }

  function extractProductCountFromHtml(html) {
    if (!html) return '';
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const source = parsed.querySelector('[data-rf-product-count-display]')
      || parsed.querySelector('[data-rf-products-count]')
      || parsed.querySelector('[data-rf-product-count]')
      || parsed.querySelector('.rf-collection-listing__toolbar .count');
    if (!source) return '';
    return (source.getAttribute('data-rf-products-count') || source.textContent || '').trim();
  }

  function syncProductCountFromGrid() {
    const countEl = document.querySelector('#CollectionProductGrid [data-rf-products-count]');
    if (!countEl) return '';
    return (countEl.getAttribute('data-rf-products-count') || countEl.textContent || '').trim();
  }

  function updateProductCountDisplay(count) {
    if (count === '' || count == null) return;
    document.querySelectorAll('[data-rf-product-count-display]').forEach((el) => {
      el.textContent = count;
      el.setAttribute('data-rf-product-count', count);
    });
  }

  function syncProductCount(html) {
    const fromHtml = extractProductCountFromHtml(html);
    if (fromHtml !== '') {
      updateProductCountDisplay(fromHtml);
      return;
    }

    const fromGrid = syncProductCountFromGrid();
    if (fromGrid !== '') {
      updateProductCountDisplay(fromGrid);
    }
  }

  function finalizeCollectionUpdate(html) {
    syncProductCount(html);
    const fromGrid = syncProductCountFromGrid();
    if (fromGrid !== '') updateProductCountDisplay(fromGrid);
    updateSidebarClearVisibility(html);

    if (window.wishlist?.show && typeof CollectionFiltersForm !== 'undefined') {
      CollectionFiltersForm.setLocalStorageProductForWishlist();
    }

    document.querySelectorAll(SECTION_SELECTOR).forEach((sectionEl) => {
      animateGrid(sectionEl);
      syncMobileRadiosFromDesktop(sectionEl);
      bindPriceRange(sectionEl);
    });
  }

  let filtersPatchAttempts = 0;
  let collectionFiltersPatched = false;

  function ensureCollectionFiltersPatch() {
    if (collectionFiltersPatched) return;

    if (typeof CollectionFiltersForm === 'undefined') {
      filtersPatchAttempts += 1;
      if (filtersPatchAttempts < 200) {
        window.setTimeout(ensureCollectionFiltersPatch, 50);
      }
      return;
    }

    if (!document.querySelector('[data-rf-collection-listing]')) return;

    collectionFiltersPatched = true;

    const originalGetSections = CollectionFiltersForm.getSections.bind(CollectionFiltersForm);
    CollectionFiltersForm.getSections = function rfGetSections() {
      const listing = document.querySelector('[data-rf-collection-listing]');
      if (listing?.dataset.sectionId) {
        return [{ id: 'main-collection-product-grid', section: listing.dataset.sectionId }];
      }
      return originalGetSections();
    };

    const originalRender = CollectionFiltersForm.renderProductGrid.bind(CollectionFiltersForm);
    CollectionFiltersForm.renderProductGrid = function patchedRenderProductGrid(html) {
      try {
        originalRender(html);
      } catch (error) {
        replaceCollectionGrid(html);
      }
      finalizeCollectionUpdate(html);
    };
  }

  function syncPriceRangeElement(priceRange) {
    const minRange = priceRange.querySelector('[data-rf-price-range="min"]');
    const maxRange = priceRange.querySelector('[data-rf-price-range="max"]');
    const minDisplay = priceRange.querySelector('[data-rf-price-display="min"]');
    const maxDisplay = priceRange.querySelector('[data-rf-price-display="max"]');
    const minInput = priceRange.querySelector('.filter__price--min');
    const maxInput = priceRange.querySelector('.filter__price--max');

    if (!minRange || !maxRange) return;

    let min = parseFloat(minRange.value);
    let max = parseFloat(maxRange.value);
    if (Number.isNaN(min)) min = 0;
    if (Number.isNaN(max)) max = parseFloat(maxRange.max) || 0;
    if (min > max) {
      if (document.activeElement === minRange) {
        max = min;
        maxRange.value = max;
      } else {
        min = max;
        minRange.value = min;
      }
    }

    if (minInput) minInput.value = min;
    if (maxInput) maxInput.value = max;
    if (minDisplay) minDisplay.textContent = Math.round(min);
    if (maxDisplay) maxDisplay.textContent = Math.round(max);
  }

  function bindPriceRange(root) {
    root.querySelectorAll('price-range.rf-filter-price').forEach((priceRange) => {
      syncPriceRangeElement(priceRange);
    });
  }

  function bindPriceRangeDelegation() {
    if (document.body.dataset.rfPriceDelegation === 'true') return;
    document.body.dataset.rfPriceDelegation = 'true';

    document.addEventListener('input', (event) => {
      const range = event.target.closest('[data-rf-price-range]');
      if (!range) return;
      const priceRange = range.closest('price-range.rf-filter-price');
      if (priceRange) syncPriceRangeElement(priceRange);
    });
  }

  function bindCollectionFiltersIntegration() {
    ensureCollectionFiltersPatch();
  }

  function initSection(section) {
    if (section.dataset.rfCollectionInit === 'true') return;
    section.dataset.rfCollectionInit = 'true';

    bindAddToCart(section);
    bindFilterRadios(section);
    bindClearFilters(section);
    bindSort(section);
    bindSheets(section);
    bindPriceRange(section);
    syncMobileRadiosFromDesktop(section);
  }

  function initAll() {
    bindPriceRangeDelegation();
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
    bindCollectionFiltersIntegration();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector(SECTION_SELECTOR) || (event.target.matches(SECTION_SELECTOR) ? event.target : null);
    if (section) initSection(section);
    bindCollectionFiltersIntegration();
  });

  window.RfCollectionListing = {
    renderSearchParams(searchParams, event) {
      const section = document.querySelector(SECTION_SELECTOR);
      if (!section) return false;
      renderWithParams(section, searchParams, event || null);
      return true;
    },
  };
})();
